//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	props: ['property'],
	data: function data() {
		return {
			Property: this.property,
			loading: false,
			propertyData: {},
			config: {
				dateFormat: "Y-m-d"
			}
		};
	},

	watch: {
		property: function property(n, o) {
			this.Property = n;
		}
	},
	methods: {
		closeAll: function closeAll() {

			Event.$emit('confirm-delete', '', '', 'close-all-residents', 'This cannot be undone', 'Confirm');
		},
		getPropertyData: function getPropertyData() {

			var self = this;

			this.loading = true;

			axios.get('/prototype/properties/generalSettings').then(function (response) {

				self.loading = false;

				if (response.data) {
					self.propertyData = response.data;
				}
			});
		},
		inviteToAllResidents: function inviteToAllResidents() {
			var self = this;
			this.loading = true;
			axios.post('/prototype/properties/inviteToAllResidents').then(function (response) {
				self.loading = false;
				if (response.data) {
					self.propertyData = response.data;
				}
			});
		},
		toggleShow: function toggleShow() {

			var self = this,
			    gs = this.propertyData ? this.propertyData.id : null;

			if (!gs) return false;

			this.loading = true;

			axios.patch('/api/generalSettings/' + gs, this.propertyData).then(function (response) {

				self.$snotify.success('Portal show toggled');
				self.loading = false;
			});
		}
	},
	mounted: function mounted() {
		var _this = this;

		this.getPropertyData();

		Event.$on('close-all-residents', function () {

			var self = _this;

			_this.loading = true;

			axios.post('/prototype/property/blacklist-property', { property: _this.property }).then(function () {
				self.loading = false;
				_this.$snotify.success('The property has been closed off from the portal');
				_this.getPropertyData();
			});
		});
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/settings/PropertyActions.vue
// module id = C+tL
// module chunks = 0 1